import { memo } from 'react';
import { Search } from 'lucide-react';
import { ILeadSecondaryFiltersProps, TLeadType, TLeadSortOption } from '@/@types/leads';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const typeOptions: { value: TLeadType | 'all'; label: string }[] = [
  { value: 'all', label: 'All Types' },
  { value: 'buyer', label: 'Buyer' },
  { value: 'seller', label: 'Seller' },
  { value: 'investor', label: 'Investor' },
  { value: 'renter', label: 'Renter' },
  { value: 'landlord', label: 'Landlord' },
];

const sortOptions: { value: TLeadSortOption; label: string }[] = [
  { value: 'last_contact', label: 'Last Contact' },
  { value: 'name', label: 'Name' },
  { value: 'created', label: 'Created' },
];

export const LeadSecondaryFilters = memo(function LeadSecondaryFilters({
  typeFilter,
  searchQuery,
  sortBy,
  onTypeChange,
  onSearchChange,
  onSortChange,
}: ILeadSecondaryFiltersProps) {
  return (
    <div className="flex items-center gap-4 h-[52px] px-6 border-b border-table-row-border">
      {/* Type Select */}
      <Select value={typeFilter} onValueChange={value => onTypeChange(value as TLeadType | 'all')}>
        <SelectTrigger className="w-[200px] h-10 bg-style-dropdown-bg border-style-dropdown-border text-muted-foreground">
          <SelectValue placeholder="All Types" />
        </SelectTrigger>
        <SelectContent>
          {typeOptions.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Search Input */}
      <div className="relative w-60 h-10 bg-background-input border border-border rounded-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          type="text"
          placeholder="Search leads..."
          value={searchQuery}
          onChange={e => onSearchChange(e.target.value)}
          className="w-full h-full bg-transparent pl-9 pr-3 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none rounded-md"
        />
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Sort */}
      <span className="text-sm text-muted-foreground">Sort by:</span>
      <Select value={sortBy} onValueChange={value => onSortChange(value as TLeadSortOption)}>
        <SelectTrigger className="w-[160px] h-10 bg-style-dropdown-bg border-style-dropdown-border text-muted-foreground">
          <SelectValue placeholder="Last Contact" />
        </SelectTrigger>
        <SelectContent>
          {sortOptions.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});
